<template>
    <div>
        <el-form :inline="true" size="mini" class="demo-form-inline" label-width="120px" :model="invtForm">
           <!-- <el-form-item label="数据状态" >
                <el-input></el-input>
            </el-form-item> -->
             <!-- <el-form-item label="企业类型" >
                <el-input></el-input>
            </el-form-item> -->
             <!-- <el-form-item label="企业海关编码" >
                <el-input></el-input>
            </el-form-item> -->
             <el-form-item label="预录入统一编号" >
                <el-input clearable  v-model="invtForm.seqNo" placeholder="请输入预录入统一编号"></el-input>
            </el-form-item>
             <el-form-item label="进出口类型" >
                <el-select clearable  class="width_100" placeholder="请选择进出口类型" :default-first-option="true" v-model="invtForm.ieFlag">
                    <el-option v-for="item in importsExportsCodeList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName" :value="item.codeValue">
                        <span class="margin_right_20">{{ item.codeValue }}</span>
                        <span >{{ item.codeName }}</span> 
                    </el-option>
                </el-select>
            </el-form-item>
             <el-form-item label="清单编号" >
                <el-input clearable  v-model="invtForm.invtNo" placeholder="请输入清单编号"></el-input>
            </el-form-item>
             <!-- <el-form-item label="账册编号" >
                <el-input></el-input>
            </el-form-item> -->
            <!-- <el-form-item label="经营单位编码" >
                <el-input></el-input>
            </el-form-item> -->
            <el-form-item label="经营单位名称" >
                <el-select clearable  filterable remote :remote-method="getEnterpriseList" :default-first-option="true"
                    placeholder="请选择经营单位" v-model="invtForm.bizopName">
                    <el-option v-for="item in enterpriseList" :key="item.id" :label="item.companyName" :value="item.companyName">
                        <span>{{ item.companyName }}</span>
                    </el-option>
                </el-select>
            </el-form-item>
             <el-form-item label="企业内部编号" >
                <el-input clearable  v-model="invtForm.interNo" placeholder="请输入企业内部编号"></el-input>
            </el-form-item>
             <!-- <el-form-item label="核扣标志" >
                <el-input></el-input>
            </el-form-item> -->
             <!-- <el-form-item label="申报类型" >
                <el-input></el-input>
            </el-form-item> -->
             <el-form-item label="录入日期" >
                <el-date-picker clearable  v-model="createDate" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
                 end-placeholder="结束日期" unlink-panels :picker-options="pickerOptions"  @change="getCreateDate">
                </el-date-picker>
            </el-form-item>
             <el-form-item label="申报日期" >
                <el-date-picker clearable  v-model="declDate" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
                 end-placeholder="结束日期" unlink-panels :picker-options="pickerOptions" @change="getdeclDate" >
                </el-date-picker>
            </el-form-item>
            <el-form-item label=" " label-width="0" >
                <el-button size="mini" type="primary" plain round @click="getInvListBy">查询</el-button>
                <el-button size="mini" type="warning" plain round @click="clearForm">清空</el-button>
                <!-- <el-button size="mini" type="success" plain round>历史查询</el-button> -->
            </el-form-item>
        </el-form>
        <!-- <div class="top_flex">
            <el-button type="primary" icon="el-icon-plus" size="mini"">查看明细</el-button>
            <el-button type="primary" icon="el-icon-copy-document" size="mini">修改</el-button>
            <el-button type="primary" icon="el-icon-document-checked" size="mini">查看回执</el-button>
            <el-button type="primary" icon="el-icon-document-remove" size="mini" >复制</el-button>
            <el-button type="primary" icon="el-icon-printer" size="mini">打印</el-button>
            <el-button type="primary" icon="el-icon-upload" size="mini" >批量打印</el-button>
            <el-button type="primary" icon="el-icon-tickets" size="mini">详情导出</el-button>
            <el-button type="primary" icon="el-icon-tickets" size="mini">批量导出</el-button>
            <el-button type="primary" icon="el-icon-tickets" size="mini">列表导出</el-button>
            <el-button type="primary" icon="el-icon-tickets" size="mini">删除申请</el-button>
            <el-button type="primary" icon="el-icon-tickets" size="mini">修改申请</el-button>
        </div> -->
        <el-table style="width: 100%;"  ref="invtTable" :data="invtTable" size="mini"  height="calc(100vh - 259px)" :header-cell-style="{'text-align':'center'}"
        @row-dblclick="details">
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column type="index" width="50"></el-table-column>
            <el-table-column label="预录入统一编号" prop="seqNo" width="130" align="center" sortable> </el-table-column>
            <el-table-column label="清单编号" prop="invtNo" align="center"  width="130" sortable> </el-table-column>
            <!-- <el-table-column label="清单类型" prop="invtType" align="center"> </el-table-column> -->
            <el-table-column label="进出口标识" prop="impexpMarkcd" align="center"> 
                <template slot-scope="scope">
                    <div v-if="scope.row.impexpMarkcd == 'I'">进口</div>
                    <div v-else>出口</div>
                </template>
            </el-table-column>
            <el-table-column label="账册编号" prop="putrecNo" align="center"  width="130" sortable> </el-table-column>
            <!-- <el-table-column label="申报类型" prop="dclTypecd" align="center"> </el-table-column> -->
            <!-- <el-table-column label="数据状态" prop="seqNo"align="center"> </el-table-column> -->
            <!-- <el-table-column label="核扣标志" prop="seqNo" align="center"> </el-table-column> -->
            <!-- <el-table-column label="核销标志" prop="vrfdedMarkcd" align="center"> </el-table-column> -->
            <el-table-column label="企业内部编号" prop="etpsInnerInvtNo" width="130" align="center" sortable> </el-table-column>
            <el-table-column label="经营单位名称" prop="bizopEtpsNm"  align="center" sortable> </el-table-column>
            <el-table-column label="加工单位名称" prop="rcvgdEtpsNm"  align="center" sortable> </el-table-column>
            <el-table-column label="进出口口岸" prop="dclPlcCuscdValue" align="center" width="110" sortable> </el-table-column>
            <el-table-column label="监管方式" prop="supvModecdValue" align="center" width="100" sortable> </el-table-column>
            <el-table-column label="报关标志" prop="dclcusFlagValue" align="center" width="100" sortable> </el-table-column>
            <!-- <el-table-column label="报关类型" prop="dclcusTypecd" align="center"> </el-table-column> -->
            <el-table-column label="申报日期" prop="declareDate" align="center" sortable width="100"> </el-table-column>
            <el-table-column label="初审人" align="center" width="100" sortable prop="inputerName"></el-table-column>
            <el-table-column label="复审人" align="center" width="100" sortable prop="checker"></el-table-column>
            <el-table-column label="" align="center" width="120" >
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" plain     @click="upload(scope.row)" >资料上传</el-button>
                </template>
            </el-table-column>
            <!-- <el-table-column label="报关单统一编号" prop="seqNo" width="120" align="center"> </el-table-column> -->
            <!-- <el-table-column label="对应报关单编号" prop="entryNo" width="120" align="center"> </el-table-column> -->
            <!-- <el-table-column label="关联报关单编号" prop="rltEntryNo" width="120" align="center"> </el-table-column> -->
            <!-- <el-table-column label="关联报关单境内收发货人名称" prop="rltEntryBizopEtpsNm" width="180" align="center"> </el-table-column> -->
        </el-table>
        <div class="tip_box">
            <span>友情提示：</span>
            <span>（1）核注清单<span class="color_red">【修改申请】、【删除申请】不能同时操作。</span></span>
            <span>（2）当核注清单申报类型为【修改】或【删除】，数据状态为【暂存】或【退单】时，如需<span class="color_red">取消本次申请</span>，请点击<span class="color_red">【修改】按钮</span>，进入到核注清单详情页面，点击<span class="color_red">【删除】按钮</span>，即可<span class="color_red">恢复</span>本次申请前的<span class="color_red">【审批通过】</span>状态数据。</span>
            <span>（3）当核注清单申报类型为【修改】，数据状态为【暂存】或【退单】时，如需进行核注清单【删除申请】，请先同（2）操作恢复为【审批通过】状态，再进入核注清单查询页面进行<span class="color_red">【删除申请】</span>操作。</span>
            <span>（4）当核注清单申报类型为【删除】，数据状态为【退单】时，如需进行核注清单【修改申请】，请先同（2）操作恢复为【审批通过】状态，再进入核注清单查询页面进行<span class="color_red">【修改申请】</span>操作。</span>
        </div>
        <!-- 上传随附单证 -->
    <uploadDocuments :uploadShow="uploadShow" :id="id" @uploadClose="uploadClose" :isDeclareUpload="true"></uploadDocuments>
    </div>
</template>
<script>
import AEObasicData from '@/config/AEObasicData.js'
import uploadDocuments from '@/components/AEO/uploadDocuments.vue'

export default {
    name: 'invtSelect',
    components:{
        uploadDocuments
    },
    watch: {
        
    },
    data() {
        return {
            invtForm:{
                invtType:'', // 清单类型
                invtNo:'', // 清单编号
                seqNo:'', // 预录入统一编号
                ieFlag:'', // 进出口类型
                interNo:'', // 企业内部编号
                createDateStart:'', // 开始录入日期
                createDateEnd:'', // 结束录入日期
                declDateStart:'', // 开始申报日期
                declDateEnd:'', // 结束申报日期
                bizopName:'', // 经营单位名称
            },
            createDate:[], // 录入时间
            declDate:[], // 申报时间
            invtTable:[],
            pickerOptions: {
                shortcuts: [{
                    text: '当天',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        picker.$emit('pick', [start, end]);
                    }
                },{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }],
            },
            id:'', // 查询随附单证id
            uploadShow:false,
            importsExportsCodeList:AEObasicData.importsExportsCodeList, // 进出口标志
            enterpriseList:[], // 企业列表
        }
    },
    mounted() {
        // this.getInvListBy()
    },
    methods: {
        getInvListBy(){
            this.$api.getInvListBy( this.invtForm ).then(res =>{
                this.invtTable = res
                // 将code值转换成对应的值
                this.invtTable = this.getCodeValue(this.invtTable)
            })
        },
        getCodeValue(list){
            list.map(listItem =>{
                // 进出口岸
                listItem.dclPlcCuscdValue =  AEObasicData.CUS_CUSTOMS.filter(item =>
                    item.codeValue.includes(listItem.dclPlcCuscd))[0].codeName
                // 监管方式
                listItem.supvModecdValue =  AEObasicData.CUS_MAPPING_TRADE_CODE_V.filter(item =>
                    item.codeValue.includes(listItem.supvModecd))[0].codeName
                // 报关标志
                listItem.dclcusFlagValue =  AEObasicData.INVT_DCLCUS_FLAG.filter(item =>
                    item.codeValue.includes(listItem.dclcusFlag))[0].codeName
            })
            return list
        },
        // 获取企业列表
        getEnterpriseList(value){
            this.$api.getCompanyList(  {companyName:value } ).then(res =>{
                this.enterpriseList = res.tableData
            })
        },
        getCreateDate(value){
            if(value){
                this.invtForm.createDateStart = value[0]
                this.invtForm.createDateEnd = value[1]
            }else{
                this.invtForm.createDateStart = ''
                this.invtForm.createDateEnd = ''
            }
        },
        getdeclDate(value){
            if(value){
                this.invtForm.declDateStart = value[0]
                this.invtForm.declDateEnd = value[1]
            }else{
                this.invtForm.declDateStart = ''
                this.invtForm.declDateEnd = ''
            }
        },
        clearForm(){
            this.invtForm = {
                invtType:'', // 清单类型
                invtNo:'', // 清单编号
                seqNo:'', // 预录入统一编号
                ieFlag:'', // 进出口类型
                interNo:'', // 企业内部编号
                createDateStart:'', // 开始录入日期
                createDateEnd:'', // 结束录入日期
                declDateStart:'', // 开始申报日期
                declDateEnd:'', // 结束申报日期
                bizopName:'', // 经营单位名称
            }
            this.createDate = [] // 录入时间
            this.declDate = [] // 申报时间
        },
        upload(data){
            this.id = data.id
            this.uploadShow = true
        },
        // 关闭上传单证弹窗
        uploadClose(){
            this.id = ''
            this.uploadShow = false
        },
        details(row, column, event){
            var submenuLabel = ''
            var submenuPath = ''
            var submenuName = ''
            // 判断进出口
            if(row.impexpMarkcd === 'E'){
                // 出口
                submenuLabel = '出口保税核注-' + (row.seqNo? row.seqNo :row.id)
                submenuPath = '/invtExport?id=' + row.id
                submenuName = 'invtExport' + row.id
            }else{
                // 进口
                submenuLabel = '进口保税核注-' + (row.seqNo? row.seqNo :row.id)
                submenuPath = '/invtImport?id=' + row.id
                submenuName = 'invtImport' + row.id
            }
            this.$store.commit('addKeepAliveCache', submenuName)
            var submenu = {
                path: submenuPath,
                name: submenuName,
                label: submenuLabel,
            }
            //修改选中菜单
            this.$store.commit('selectMenu', submenu)
            this.$nextTick(() => {
                this.$router.push({
                    path: submenuPath,
                    query: { id: row.id, entryNo: row.entryNo, seqNo: row.seqNo }
                });
            });
            // this.$router.push({
            //     path: submenuPath,
            //     query: {
            //         id: row.id,
            //         entryNo:row.entryNo,
            //         seqNo:row.seqNo,
            //     }
            // })
        }
    },
}
</script>
<style lang="css" scoped>

.el-form-item--mini.el-form-item, .el-form-item--small.el-form-item{
    margin-bottom: 5px;
}
.top_flex{
    margin: 10px 10px;
    display: flex;
    align-items: center;
}
.top_flex .el-button--mini {
    padding: 3px 4px;
    font-size: 12px;
}
/*提示 */
.tip_box{
    padding: 10px 30px;
    font-size: 12px;
    color: #3c3c3c;
    display: flex;
    flex-direction: column;
}
.color_red{
    color: red;
}
::v-deep .el-table__body tr:hover>td {
  background-color: #c4e7ff !important; /* 浅蓝色背景示例 */
}
.margin_right_20{
    margin-right: 20px;
}
.width_100{
    width: 100%;
}
.el-table {
    margin-top: 0px;
}
</style>